import { CreateOauthClientRequestDto, OAuthClientDto } from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';

class Actions extends CaEntityActionsFactory<
  OAuthClientDto,
  Partial<CreateOauthClientRequestDto>,
  OAuthClientDto,
  BaseFilterType
> {
  constructor() {
    super('oauthClients');
  }
}

export const OauthClientsActions = new Actions();
